const Minus = () => {
    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M36.6673 19.9999C36.6673 29.2047 29.2054 36.6666 20.0007 36.6666C10.7959 36.6666 3.33398 29.2047 3.33398 19.9999C3.33398 10.7952 10.7959 3.33325 20.0007 3.33325C29.2054 3.33325 36.6673 10.7952 36.6673 19.9999ZM26.2507 19.9999C26.2507 20.6903 25.691 21.2499 25.0007 21.2499H15.0007C14.3103 21.2499 13.7507 20.6903 13.7507 19.9999C13.7507 19.3096 14.3103 18.7499 15.0007 18.7499H25.0007C25.691 18.7499 26.2507 19.3096 26.2507 19.9999Z" fill="url(#paint0_linear_273_3431)" />
            <defs>
                <linearGradient id="paint0_linear_273_3431" x1="20.0007" y1="3.33325" x2="20.0007" y2="19.8426" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#1C225A" />
                    <stop offset="1" stopColor="#3B49C0" />
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Minus